import { mapProcedureLabelToCanonicalVisual } from "../../../utils/toothVisualMapping";

export function getEmptyChartState(): Record<string, string> {
  const allTeeth = [
    "UR8", "UR7", "UR6", "UR5", "UR4", "UR3", "UR2", "UR1",
    "UL1", "UL2", "UL3", "UL4", "UL5", "UL6", "UL7", "UL8",
    "LR8", "LR7", "LR6", "LR5", "LR4", "LR3", "LR2", "LR1",
    "LL1", "LL2", "LL3", "LL4", "LL5", "LL6", "LL7", "LL8"
  ];

  const state: Record<string, string> = {};
  allTeeth.forEach(t => state[t] = "Normal");
  return state;
}

export type ToothVisualState =
  | "Normal"
  | "Crown"
  | "Veneer"
  | "RCT_Open"
  | "RCT_Done"
  | "Filling"
  | "Implant"
  | "Missing";

export function getVisualStateFromProc(name: string): ToothVisualState {
  const canonical = mapProcedureLabelToCanonicalVisual(name);
  if (canonical === "missing") return "Missing";
  if (canonical === "implant") return "Implant";
  if (canonical === "crown") return "Crown";
  if (canonical === "rct_open") return "RCT_Open";
  if (canonical === "rct_done" || canonical === "rct_cc" || canonical === "rct_crown") return "RCT_Done";
  if (canonical === "filling") return "Filling";
  if (String(name || "").toLowerCase().includes("veneer")) return "Veneer";
  return "Normal";
}

export interface AutoSuggestItem {
  tooth: string;
  proc: string;
}

export function autoSuggestFromDoctorState(chartState: Record<string, string> | null | undefined): AutoSuggestItem[] {
  const suggestions: AutoSuggestItem[] = [];

  Object.entries(chartState || {}).forEach(([tooth, visual]) => {
    if (visual === "RCT_Done") {
      suggestions.push({ tooth, proc: "Root Canal Treatment" });
      suggestions.push({ tooth, proc: "Crown" });
    }
    if (visual === "Crown") {
      suggestions.push({ tooth, proc: "Crown" });
    }
    if (visual === "Implant") {
      suggestions.push({ tooth, proc: "Implant Placement" });
    }
  });

  return suggestions;
}
